var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.partnerChip)?_c('div',[_vm._v(_vm._s(_vm.partnerChip.name)+" - "+_vm._s(_vm.partnerChip.orgNumber))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }